// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'secondary', 'secondary Fallback'","fontWeight":700,"fontStyle":"normal"},"className":"__className_10b73f","variable":"__variable_10b73f"};